export default "__VITE_ASSET__DhqqONM$__"